<div [ngClass]="containerClasses()">
  @for (item of counter(count()); track $index) {
  <div class="supplier-card-skeleton">
    <div class="supplier-card-skeleton__left">
      <ngx-skeleton-loader count="1" class="w-188 flex gap-30" [theme]="{
          height: '11.75em',
          'border-radius': '0.625em',
          'margin-bottom': '0',
        }"></ngx-skeleton-loader>
      <ngx-skeleton-loader count="1" class="w-188 flex gap-30" [theme]="{
          height: '3.125em',
          'border-radius': '0.625em',
          'margin-bottom': '0',
        }"></ngx-skeleton-loader>
    </div>
    <div class="supplier-card-skeleton__right">
      <div class="supplier-card-skeleton__right-top">
        <pwj-card-property-skeleton [count]="1" class="flex"></pwj-card-property-skeleton>
        <ngx-skeleton-loader count="1" class="w-50 flex gap-30" [theme]="{
          height: '2em',
          'border-radius': '0.25em',
          'margin-bottom': '0',
        }"></ngx-skeleton-loader>
      </div>
    <div class="supplier-card-skeleton__right-bottom">
      <div>
        <ngx-skeleton-loader count="1" class="w-80 flex gap-30" [theme]="{
          height: '1.5em',
          'border-radius': '0.625em',
          'margin-bottom': '0.5em',
        }"></ngx-skeleton-loader>
         <ngx-skeleton-loader count="1" class="w-120 flex gap-30" [theme]="{
          height: '1.5em',
          'border-radius': '0.625em',
          'margin-bottom': '0',
        }"></ngx-skeleton-loader>
       </div>
       <div>
        <ngx-skeleton-loader count="1" class="w-100 flex gap-30" [theme]="{
          height: '1.5em',
          'border-radius': '0.625em',
          'margin-bottom': '0.5em',
        }"></ngx-skeleton-loader>
         <ngx-skeleton-loader count="1" class="w-144 flex gap-30" [theme]="{
          height: '1.5em',
          'border-radius': '0.625em',
          'margin-bottom': '0',
        }"></ngx-skeleton-loader>
       </div>
       <div>
        <ngx-skeleton-loader count="1" class="w-100 flex gap-30" [theme]="{
          height: '1.5em',
          'border-radius': '0.625em',
          'margin-bottom': '0.5em',
        }"></ngx-skeleton-loader>
         <ngx-skeleton-loader count="1" class="w-144 flex gap-30" [theme]="{
          height: '1.5em',
          'border-radius': '0.625em',
          'margin-bottom': '0',
        }"></ngx-skeleton-loader>
       </div>
    </div>
    </div>
  </div>
  }
</div>